import React, { useState } from "react";
import { auth } from "../firebase/firebaseConfig";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import logotipo_recortado from "../images/logotipo-horizontal_con-nombre_recortado.png";

export default function Register() {
  const navigate = useNavigate();

  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [categoriaProfesional, setCategoriaProfesional] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  // ✔️ Estados para aceptación legal
  const [aceptoTerminos, setAceptoTerminos] = useState(false);
  const [aceptoPrivacidad, setAceptoPrivacidad] = useState(false);

  // ✔️ Estados para mostrar modales
  const [showModalTerminos, setShowModalTerminos] = useState(false);
  const [showModalPrivacidad, setShowModalPrivacidad] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);

    // ✔️ Validaciones legales
    if (!aceptoTerminos)
      return setError("Debe aceptar los términos y condiciones de uso.");
    if (!aceptoPrivacidad)
      return setError("Debe aceptar la política de privacidad.");

    // ✔️ Validaciones normales
    if (!nombre.trim()) return setError("El nombre es obligatorio");
    if (!apellidos.trim()) return setError("Los apellidos son obligatorios");
    if (!username.trim()) return setError("El nombre de usuario es obligatorio");
    if (!email) return setError("El correo es obligatorio");
    if (!categoriaProfesional)
      return setError("La categoría profesional es obligatoria.");
    if (password.length < 6)
      return setError("La contraseña debe tener al menos 6 caracteres");
    if (password !== passwordConfirm)
      return setError("Las contraseñas no coinciden");

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

await updateProfile(userCredential.user, {
  displayName: username.trim(),
});

      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* LOGO */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
        <img
          src={logotipo_recortado}
          alt="Logo DISFAGIAPP recortado"
          style={{ maxWidth: "300px", height: "auto" }}
        />
      </div>

      {/* CONTENEDOR DEL FORMULARIO */}
      <div
        style={{
          maxWidth: "400px",
          margin: "1rem auto 2rem auto",
          padding: "2rem",
          border: "1px solid #ddd",
          borderRadius: "8px",
          fontFamily: "sans-serif",
        }}
      >
        {error && (
          <div
            style={{
              marginBottom: "1rem",
              padding: "0.5rem",
              backgroundColor: "#fdecea",
              color: "#b71c1c",
              borderRadius: "4px",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleRegister}>
          {/* NOMBRE */}
          <label htmlFor="nombre" style={{ display: "block", marginBottom: 4 }}>
            Nombre:
          </label>
          <input
            type="text"
            id="nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              marginBottom: "1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          />

          {/* APELLIDOS */}
          <label htmlFor="apellidos" style={{ display: "block", marginBottom: 4 }}>
            Apellidos:
          </label>
          <input
            type="text"
            id="apellidos"
            value={apellidos}
            onChange={(e) => setApellidos(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              marginBottom: "1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          />

          {/* USUARIO */}
          <label htmlFor="username" style={{ display: "block", marginBottom: 4 }}>
            Nombre de usuario:
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              marginBottom: "1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          />

          {/* EMAIL */}
          <label htmlFor="email" style={{ display: "block", marginBottom: 4 }}>
            Correo electrónico:
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              marginBottom: "1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          />

          {/* CATEGORÍA PROFESIONAL */}
          <label htmlFor="categoriaProfesional" style={{ display: "block", marginBottom: 4 }}>
            Categoría profesional:
          </label>

          <select
            id="categoriaProfesional"
            value={categoriaProfesional}
            onChange={(e) => setCategoriaProfesional(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              marginBottom: "1rem",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
            required
          >
            <option value="">Seleccione una opción</option>
            <option value="medico">Médico/a</option>
            <option value="enfermero">Enfermero/a</option>
            <option value="farmaceutico">Farmacéutico/a</option>
            <option value="tcae">TCAE</option>
            <option value="nutricionista">Nutricionista</option>
            <option value="logopeda">Logopeda</option>
            <option value="trabajador-social">Trabajador/a social</option>
            <option value="fisioterapeuta">Fisioterapeuta</option>
            <option value="otro">Otro</option>
          </select>

          {/* CONTRASEÑA */}
          <label htmlFor="password" style={{ display: "block", marginBottom: 4 }}>
            Contraseña:
          </label>
          <div style={{ position: "relative", marginBottom: "1rem" }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem 2.5rem 0.5rem 0.5rem",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
              minLength={6}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#5986bd",
              }}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>

          {/* CONFIRMAR CONTRASEÑA */}
          <label htmlFor="passwordConfirm" style={{ display: "block", marginBottom: 4 }}>
            Confirmar contraseña:
          </label>
          <div style={{ position: "relative", marginBottom: "1.5rem" }}>
            <input
              type={showPasswordConfirm ? "text" : "password"}
              id="passwordConfirm"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem 2.5rem 0.5rem 0.5rem",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
              minLength={6}
            />
            <span
              onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#5986bd",
              }}
            >
              {showPasswordConfirm ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>

          {/* ✔️ CHECKS LEGALES */}
          <div style={{ marginBottom: "0.75rem", fontSize: "0.9rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <input
                type="checkbox"
                checked={aceptoTerminos}
                onChange={(e) => setAceptoTerminos(e.target.checked)}
              />
              Acepto los{" "}
              <span
                style={{
                  color: "#5986bd",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => setShowModalTerminos(true)}
              >
                términos y condiciones de uso
              </span>
            </label>
          </div>

          <div style={{ marginBottom: "1.5rem", fontSize: "0.9rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <input
                type="checkbox"
                checked={aceptoPrivacidad}
                onChange={(e) => setAceptoPrivacidad(e.target.checked)}
              />
              Acepto la{" "}
              <span
                style={{
                  color: "#5986bd",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => setShowModalPrivacidad(true)}
              >
                política de privacidad
              </span>
            </label>
          </div>

          {/* BOTÓN REGISTRARSE */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.75rem",
              backgroundColor: "#5986bd",
              color: "white",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#225491")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#5986bd")}
          >
            {loading ? "Registrando..." : "Registrarse"}
          </button>
        </form>

        {/* YA TIENE CUENTA */}
        <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
          <p style={{ marginBottom: "0.5rem" }}>¿Ya tienes cuenta?</p>
          <button
            onClick={() => navigate("/")}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#5986bd",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Iniciar sesión
          </button>
        </div>
      </div>

      {/* MODAL TÉRMINOS */}
      {showModalTerminos && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1rem",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "8px",
              maxWidth: "500px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <h3
              style={{
                fontWeight: "bold",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              Términos y condiciones de uso
            </h3>

            <p style={{ textAlign: "justify" }}>
              Estos términos regulan el acceso y uso de la aplicación DisfagiApp. 
              Al registrarse y utilizarla, el usuario acepta expresamente estas 
              condiciones, así como la normativa vigente en materia de protección 
              de datos.<br/><br/>

              <b>1. Objeto del servicio</b><br/><br/>
              La aplicación ofrece herramientas digitales destinadas a apoyar a 
              profesionales sanitarios en el manejo de la disfagia. No sustituye 
              la valoración clínica de un profesional sanitario.<br/><br/>

              <b>2. Registro y veracidad de los datos</b><br/><br/>
              El usuario debe registrarse facilitando datos personales 
              identificativos. El usuario garantiza que estos datos son veraces.<br/><br/>

              <b>3. Uso clínico: anonimización de datos de pacientes</b><br/><br/>
              La aplicación NO recoge ni trata datos de salud de pacientes.<br/><br/>

              Los profesionales deben introducir únicamente datos anonimizados 
              (p. ej.: Caso-001), sin posibilidad de identificar al paciente.<br/><br/>

              <b>4. Obligaciones del usuario</b><br/><br/>
              - Utilizar la aplicación de forma adecuada.<br/>
              - No introducir datos personales de pacientes.<br/>
              - Mantener la confidencialidad de sus credenciales.<br/><br/>

              <b>5. Responsabilidad</b><br/><br/>
              El responsable no garantiza la recuperación de datos borrados 
              accidentalmente. Tampoco se responsabiliza de un uso incorrecto de 
              la aplicación.<br/><br/>

              <b>6. Comunicaciones electrónicas</b><br/><br/>
              El usuario puede recibir avisos operativos si ha dado su 
              consentimiento.<br/><br/>

              <b>7. Modificación de los términos</b><br/><br/>
              Podrán actualizarse en cualquier momento, notificándose a través del 
              correo <a href="mailto:disfagiapp.mail@gmail.com?subject=Modificación%20de%20los%20términos" className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">disfagiapp.mail@gmail.com</a><br/><br/>

              Al continuar, declara haber leído y aceptado estos términos.<br/><br/>
            </p>

            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => setShowModalTerminos(false)}
                style={{
                  marginTop: "1rem",
                  backgroundColor: "#5986bd",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL PRIVACIDAD */}
      {showModalPrivacidad && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1rem",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "8px",
              maxWidth: "500px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <h3
              style={{
                fontWeight: "bold",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              Política de privacidad
            </h3>

            <p style={{ textAlign: "justify" }}>
              Esta política explica cómo se tratan los datos personales del usuario 
              en la aplicación DisfagiApp®, de conformidad con el RGPD y la LOPDGDD.<br/><br/>

              <b>1. Responsable del tratamiento</b><br/><br/>
              INiBICA actúa como responsable del tratamiento de los datos facilitados 
              durante el registro (nombre, apellidos, correo, usuario, categoría).<br/><br/>

              Importante: La empresa desarrolladora y Fresenius Kabi España, S.A.U. 
              no tienen acceso a los datos introducidos por profesionales ni realizan 
              ningún tratamiento sobre ellos. Toda la información clínica se gestiona 
              localmente por los profesionales, sin posibilidad de identificar a 
              pacientes.<br/><br/>

              <b>2. Datos que se recogen</b><br/><br/>
              Se recogen ÚNICAMENTE datos proporcionados por el usuario para registro 
              y acceso. No se tratan datos clínicos de pacientes.<br/><br/>

              <b>3. Finalidad</b><br/><br/>
              - Gestionar la cuenta de usuario.<br/>
              - Permitir el acceso a la aplicación.<br/>
              - Enviar avisos operativos (si el usuario lo consiente).<br/><br/>

              <b>4. Legitimación</b><br/><br/>
              El tratamiento se basa en el consentimiento del usuario y en la 
              necesidad de gestionar su acceso al servicio.<br/><br/>

              <b>5. Conservación</b><br/><br/>
              Los datos se conservarán mientras el usuario mantenga la cuenta activa 
              y posteriormente durante el plazo legal.<br/><br/>

              <b>6. Destinatarios</b><br/><br/>
              No se comunicarán datos a terceros salvo obligación legal.<br/><br/>

              <b>7. Derechos del usuario</b><br/><br/>
              Puede ejercer sus derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad 
              a través del correo <a href="mailto:disfagiapp.mail@gmail.com?subject=Derechos%20del%20usuario" className="text-blue-600 hover:underline" target="_blank"  rel="noreferrer">disfagiapp.mail@gmail.com</a><br/><br/>

              <b>8. Seguridad</b><br/><br/>
              Se aplican medidas técnicas y organizativas para proteger la 
              información. No se garantiza la recuperación de datos eliminados por 
              el usuario.<br/><br/>

              <b>9. Comunicaciones comerciales</b><br/><br/>
              Solo se enviarán si el usuario ha dado su consentimiento previo.<br/><br/>

              Al registrarse, el usuario acepta esta política de privacidad.<br/><br/>
            </p>

            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => setShowModalPrivacidad(false)}
                style={{
                  marginTop: "1rem",
                  backgroundColor: "#5986bd",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}